/**
 * What the `user` cookie holds: who is signed in, never the whole user.
 *
 * The cookie only says a session is there (with `accessToken`); every render
 * reads the full user from /auth/me. It used to hold the whole sign-in
 * response, access token and club id lists included, which for an admin of a
 * handful of clubs passes 4 KB once encoded. A browser silently refuses a
 * cookie that size, so the sign-in "worked" in the open tab and every reload
 * or new tab started signed out (X210, 28 Oct 2026). Kept as the same JSON
 * string the cookie always carried, so reading it back is unchanged.
 */
const SESSION_USER_FIELDS = ['id', 'playerId', 'firstName', 'lastName', 'fullName', 'superAdmin'];

export function sessionUserCookieValue(user) {
    if (!user) return null;
    let source = user;
    if (typeof source === 'string') {
        try {
            source = JSON.parse(source);
        } catch {
            return source.length < 1024 ? source : null;
        }
    }
    if (!source || typeof source !== 'object') return null;
    const slim = {};
    for (const field of SESSION_USER_FIELDS) {
        if (source[field] !== undefined) slim[field] = source[field];
    }
    return JSON.stringify(slim);
}
